<div fxLayout="column" class="right-side-container">

    <!-- Section Header - Modern Minimal Design (same as center) -->
    <div class="section-header">
        <div class="section-header-icon">
            <mat-icon>campaign</mat-icon>
        </div>
        <span class="section-header-title">Ανακοινώσεις</span>
        <div class="section-header-line"></div>
    </div>

    <div *ngIf="!loadingChildren" fxLayout="column" class="announcements-container">
        <div *ngFor="let notification of announcements; let i = index"
             (click)="showAnnouncement(notification)"
             class="announcement-card">

            <div class="announcement-content">
                <div class="announcement-header">
                    <span class="announcement-title">{{notification.title}}</span>
                    <div *ngIf="notification.is_opened" class="read-badge" matTooltip="Διαβάστηκε">
                        <mat-icon>done_all</mat-icon>
                    </div>
                </div>

                <div class="announcement-date">
                    <mat-icon>event</mat-icon>
                    <span>{{notification.created_at ? notification.created_at : '-'}}</span>
                </div>
            </div>
        </div>

        <div *ngIf="announcements?.length === 0" class="no-announcements">
            <mat-icon>notifications_none</mat-icon>
            <span>Δεν υπάρχουν ανακοινώσεις</span>
        </div>
    </div>

    <div *ngIf="loadingChildren" class="skeleton-card">
        <div fxLayout="column" fxFlex>
            <div fxLayout="row" fxFlex>
                <ngx-skeleton-loader fxFlex="30" count="1" animation="progress"
                                     [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
            </div>
            <div fxLayout="row" fxFlex>
                <ngx-skeleton-loader fxFlex count="1" animation="progress"
                                     [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
            </div>
            <div fxLayout="row" fxFlex>
                <ngx-skeleton-loader fxFlex count="1" animation="progress"
                                     [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
            </div>
        </div>
    </div>
</div>
